import React from 'react';
import styles from './modesview.module.css';
import Grid from '@material-ui/core/Grid';
import ModesView from "./modesview";
import Box from '@material-ui/core/Box';
import Slide from '@material-ui/core/Slide';
import Tabs from '@material-ui/core/Tabs';
import InfoContainer from "./container/InfoContainer";
import SwipeableViews from 'react-swipeable-views';
import Container from '@material-ui/core/Container';
import Hidden from '@material-ui/core/Hidden';
import ReactSwipe from 'react-swipe';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Translation } from "react-i18next";



import { createMuiTheme, useTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';


export default function IndexModesView(props) {

    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down('xs'));  

    if(mobileView){
        return (
            <div className={styles.allModesView}>

                {showMobileView(props.usn)}

            </div>
        );
    }else{
        return (
            <div className={styles.allModesView}>

                {showDesktopView(props.usn)}

            </div>
        );
    }

}




    /*
        {this.ModeView('Classic Modes', 'CL')}
        {this.ModeView('Zombie Modes', 'ZM')}
        {this.ModeView('Event Modes', 'EM')}
        {this.ModeView('Clan Modes', 'CM')}
    */

    function ModeView(usn, title, gid, gridUse = true){

        var myModeChild = <Box className={styles.allModesViewBox}><ModesView usn={usn} gid={gid} /></Box>

        if(gridUse){

            return (
                <Translation>
                {
                    (t) =>
                    <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                        <div className={styles.allModesViewtitle}>{t(title)}</div>

                        {myModeChild}

                    </Grid>  
                }
                </Translation>          
            );
            // */
            /*
            return (
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <InfoContainer
                        headerLeft = {title}
                        headerRight = {null}
                        footer = {null} 
                        children = {myModeChild}
                        />
                </Grid>            
            );
            // */
        }else{
            /*
            return (
                <Grid item>

                    <div className={styles.allModesViewtitle}>{title}</div>

                    <Box className={styles.allModesViewBox}>
                        <ModesView usn={this.props.usn} gid={gid} />
                    </Box>

                </Grid>
            );
            // */

            return (
                <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                    <div className={styles.allModesViewtitle}>{title}</div>

                    {myModeChild}

                </Grid>
            );            
        }

        // */
    }

    function showDesktopView(usn){
        return(
                <Grid container spacing={2} alignItems="stretch">

                    {ModeView(usn, 'Classic Modes', 'CL')}
                    {ModeView(usn, 'Zombie Modes', 'ZM')}
                    {ModeView(usn, 'Event Modes', 'EM')}
                    {ModeView(usn, 'Clan Matches', 'CM')}

                </Grid>

        );
    }

    function showMobileView(usn){

        // react slider
        var settings = {
            dots: true,
            arrows: false,
            infinite: true,
            centerMode: true,
            centerPadding: '12px',
            slidesToShow: 1,
            slidesToScroll: 1
            //,dotsClass: 'mobileSlickDots'
        };

        return (
            <div className={styles.allModesViewContainer}>
                <Slider {...settings}>
                    <div className={styles.sliderBoxWidth}>{ModeView(usn, 'Classic Modes', 'CL', false)}</div>
                    <div className={styles.sliderBoxWidth}>{ModeView(usn, 'Zombie Modes', 'ZM', false)}</div>
                    <div className={styles.sliderBoxWidth}>{ModeView(usn, 'Event Modes', 'EM', false)}</div>
                    <div className={styles.sliderBoxWidth}>{ModeView(usn, 'Clan Modes', 'CM', false)}</div>
                </Slider>
            </div>
        );

    }    